import { useEffect, useState } from 'react';

/** Шаг тикера «сейчас» по умолчанию — минута. */
export const NOW_TICK_MS = 60_000;

/**
 * «Сейчас» (epoch millis), которое само обновляется раз в `intervalMs`.
 *
 * Перепроверка G6: «идёт сейчас» и «проведён» на карточке группы считались
 * в `useMemo([lessons])` с однократным `Date.now()` — открытая в 19:30
 * карточка держала «идёт сейчас» и в 23:00. Подставьте результат в
 * зависимости `useMemo`, и производное пересчитается на следующем тике.
 * Интервал снимается при размонтировании.
 */
export const useNow = (intervalMs: number = NOW_TICK_MS): number => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);
  return now;
};
